import React from 'react';
import Link from '../Link/Link';

export function pascalCase(str) {
  if (str && typeof str === 'string') {
    // renders string in pascal case, and removes - or &, i.e: songs-riffs => Songs Riffs
    const formattedString = str.replace(/(-|&|^)([^-&]?)/g, (_, prep, letter) =>
      letter.toUpperCase(),
    );
    // returns and removes any spaces in `formatted string`, i.e: Songs Riffs => SongsRiffs
    return formattedString.replace(/\s\s+/g, '');
  }
  return null;
}

export function renderControls(obj, onChange) {
  const { current, list, name } = obj;
  if (list && Array.isArray(list)) {
    return (
      <div>
        {list.map((listItem, key) => (
          <label
            className={`${
              listItem.title === current || listItem.value === current ? 'source-sans-b' : ''
            } flex pointer items-center justify-between ttc pa3 bg-near-white bb bt-0 bl-0 br-0 b--light-gray b--dotted dark-gray source-sans f7`}
            key={`${listItem.title || listItem.label}`}
            htmlFor={`${name}-${key}`}
          >
            <span>{listItem.title || listItem.label}</span>
            <input
              id={`${name}-${key}`}
              name={name}
              type="radio"
              value={listItem.title || listItem.value}
              onChange={onChange}
              checked={listItem.title === current || listItem.value === current}
            />
          </label>
        ))}
      </div>
    );
  }
  return null;
}

export function renderHeader(
  title,
  isBackVisible = false,
  onClick = null,
  onSecondaryClick = null,
) {
  if (title) {
    return (
      <header className="flex items-center pa3 bb b--black-10 z-5">
        {isBackVisible ? (
          <button
            type="button"
            className="ph0 mid-gray relative outline-0 button-reset bn bg-transparent pointer"
            onClick={onClick}
          >
            <i className="f4 icon-pointer-left-light" />
            <span
              className="absolute futura-heavy ttu f7"
              style={{ top: '0.4375rem', left: '1rem' }}
            >
              Back
            </span>
          </button>
        ) : null}
        <h2 className="ttu f6 tc ma0 ttu flex-auto">{title}</h2>
        <button
          type="button"
          className="mid-gray outline-0 button-reset bn bg-transparent pointer ph0"
          onClick={onSecondaryClick}
        >
          <i className="f4 icon-x" />
        </button>
      </header>
    );
  }
  return null;
}

export function renderList(obj, isMobile = false, onClick) {
  const { email, list, gutterSpacing } = obj;
  if (list && Array.isArray(list)) {
    const filteredList = list.filter(listItem => listItem.url);
    return (
      <ul className="list pl0 ma0">
        {filteredList.map(listItem => (
          <li className={`${!isMobile ? 'mb2' : ''}`} key={listItem.url}>
            <Link
              className={`
              ${
                isMobile
                  ? `${gutterSpacing ||
                      'ph3'} db pv3 bg-near-white bb bt-0 bl-0 br-0 b--light-gray b--dotted`
                  : ''
              }
              dark-gray source-sans f7`}
              onClick={
                !listItem.target
                  ? event => {
                      onClick(event, listItem.id);
                    }
                  : null
              }
              to={listItem.url || ''}
              target={listItem.target || ''}
              trackEvent={{
                eventType: 'Click Main Navigation',
                properties: {
                  navigation_core: listItem.label,
                  email,
                },
              }}
            >
              {listItem['label-prefix'] ? (
                <span className="blue pr1">{listItem['label-prefix']}</span>
              ) : null}
              <span className={listItem['class-names'] || ''}>{listItem.label}</span>
            </Link>
          </li>
        ))}
      </ul>
    );
  }
  return null;
}

export function renderTitle(obj, isSubTitle = false, isMobile = false) {
  const { entity, label, secondaryLabel } = obj;
  const setStyles = () => {
    const baseStyles = 'ttu ma0 futura-heavy mid-gray';
    if (!isMobile) {
      const subTitleStyles = `${isSubTitle ? 'f8 b--dotted mb2' : 'f7 mb3'}`;
      return `${baseStyles} ${subTitleStyles} pb2 bb bt-0 bl-0 br-0 b--light-gray`;
    }
    return `${isMobile ? 'f7' : ''} ${baseStyles}`;
  };
  return (
    <h2 className={`${setStyles()}`} data-id={`mega-nav-sub-menu-title-${label}`}>
      <div className={`${secondaryLabel ? 'mb1' : ''}`}>
        {label}
        {entity ? (
          <sup
            style={{
              fontSize: '.625rem',
              paddingLeft: '.15rem',
              top: '-.125rem',
            }}
          >
            {entity}
          </sup>
        ) : null}
      </div>
      {secondaryLabel ? <span className="f7 ttn source-sans">{secondaryLabel}</span> : null}
    </h2>
  );
}

export function renderCollapsibleContent(obj, onClick) {
  const { email, list, styles } = obj;
  if (list && Array.isArray(list)) {
    const filteredList = list.filter(listItem => listItem.items);
    return (
      <div>
        {filteredList.map(listItem => (
          <div key={`collapsible-content-list-item-${listItem.label}`}>
            <div
              className={`${styles}`}
              data-id={`collapsible-content-list-item-${listItem.label}`}
            >
              {' '}
              {listItem.label}
            </div>
            {renderList(
              {
                email,
                list: listItem.items,
                gutterSpacing: 'pl4 pr3',
              },
              true,
              onClick,
            )}
          </div>
        ))}
      </div>
    );
  }
  return null;
}
